import React from 'react';
import WindowLocation from "../Services/WindowLocation";
import axios from "axios";

export default class ListComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            params: {},
            totalPages: 0,
            totalPosts: 0,
            loadMore: false,
            loaded: false,
            list: []
        };

        this.config = (this.props && this.props.config) ? this.props.config : null;
        this.perPage = (this.config && this.config.per_page) ? this.config.per_page : null;
        this.source = (this.config && this.config.source) ? this.config.source : null;

        this.page = 1;
        this.isChangeFilter = false;
        this.refList = [];

        this.getList = this.getList.bind(this);
        this.setDefaultParams = this.setDefaultParams.bind(this);
        this.resetParams = this.resetParams.bind(this);
        this.updateParams = this.updateParams.bind(this);
        this.getResponseTotalPages = this.getResponseTotalPages.bind(this);
        this.getResponseTotalPosts = this.getResponseTotalPosts.bind(this);
        this.loadMore = this.loadMore.bind(this);
        this.incrementPage = this.incrementPage.bind(this);
        this.resetPage = this.resetPage.bind(this);
        this.requestList = this.requestList.bind(this);
        this.resetRefList = this.resetRefList.bind(this);
    }

    componentDidMount() {
        if(!window.location.getHashObj) {
            WindowLocation.getWindowLocation();
        }

        this.setDefaultParams().then(() => {
            if(window.location.hashObj && window.location.getHashObj('page') && window.location.getHashObj('page') > 1) {
                this.page = window.location.getHashObj('page');
            }

            let params = {
                page: this.page,
                forcePages: (this.page > 1),
                ...this.state.params,
                per_page: (this.config.per_page*this.page)
            };

            this.requestList(axios.get(this.source, {
                params: params
            }));
        });
    }

    setDefaultParams() {
        return new Promise(resolve => {
            const {params} = this.config;

            if (params) {
                let setDefaultParams = {};

                for (let key in params) {
                    if (!params.hasOwnProperty(key)) {
                        continue;
                    }

                    const {key: name, default: defaultValue} = params[key];
                    setDefaultParams[name] = (window.location.hashObj && window.location.getHashObj(name)) ? window.location.getHashObj(name) : (defaultValue ? defaultValue :null);
                }

                this.setState({
                    params: setDefaultParams
                }, resolve);
            } else {
                resolve();
            }

            return;
        });
    }

    resetParams(callback = () => {}) {
        const {params} = this.config;
        let resetParams = {};

        for (let key in params) {
            if (!params.hasOwnProperty(key)) {
                continue;
            }

            resetParams[params[key].key] = params[key].default ? params[key].default : null;
            window.location.removeHash(params[key].key);
        }

        resetParams.s = null;

        this.setState({
            params: resetParams
        }, callback);
    }

    updateParams(key, value) {
        this.resetPage();
        this.resetRefList();

        this.setState({
            params: {
                ...this.state.params,
                [key]: value
            }
        }, this.getList);
    }

    sleep = (miliseconde = 500) => {
        return new Promise(resolve => setTimeout(resolve, miliseconde));
    }

    getList() {
        this.setState({
            loaded: false
        }, async () => {
            await this.sleep(350);

            this.requestList(axios.get(this.source, {
                params: {
                    page: this.page,
                    ...this.state.params
                }
            }));
        });
    }

    getResponseTotalPages(request) {
        if (request && request.getResponseHeader) {
            let pages = request.getResponseHeader('x-wp-totalpages');

            this.setState({
                totalPages: pages ? parseInt(pages) : 0
            })
        }
    }

    getResponseTotalPosts(request) {
        if (request && request.getResponseHeader) {
            let posts = request.getResponseHeader('x-wp-total');

            this.setState({
                totalPosts: posts ? parseInt(posts) : 0
            })
        }
    }

    loadMore(event) {
        if (event)
            event.preventDefault();

        this.setState({
            loadMore: true
        }, () => {
            this.incrementPage();
            this.getList();
        });
    }

    incrementPage(page = null) {
        if (page) {
            this.page = page;
            return;
        }

        this.page++;
        window.location.addHash('page', this.page);
        WindowLocation.rewriteUrl();
    }

    resetPage() {
        this.page = 1;
    }

    requestList(request) {
        request.then(({data: list, request}) => {
            this.getResponseTotalPages(request);
            this.getResponseTotalPosts(request);

            const {loadMore, loaded, list: oldList} = this.state;
            let oL = oldList;

            if (!loadMore && !loaded) {
                oL = [];
            }

            this.setState({
                list: oL.concat(list),
                loaded: true,
                loadMore: false
            });
        }).catch((error) => {
            this.setState({
                loaded: true,
                loadMore: false
            });

            console.error(error);
        });
    }

    resetRefList () {
        this.refList = [];
    }
}